export default "__VITE_ASSET__D2Vq3$GH__"